import axios from 'axios'
import { Notification } from 'element-ui'

export async function getAlert(uuid) {
  try {
    const res = await axios.get(`/api/public/v1/job-alerts/${uuid}`)
    return res.data.data || {}
  } catch (error) {
    console.warn(error);
    throw error;
  }
}

export async function createAlert(model) {
  try {
    const res = await axios.post('/api/public/v1/job-alerts', model)
    return res.data.data || {}
  } catch (error) {
    const errorMessage = error.response.data.errors[0]

    if (errorMessage) {
      Notification.error({
        message: errorMessage
      })
    } else {
      Notification.error({
        message: 'Something went wrong'
      })
    }
    throw error
  }
}

export async function updateAlert(uuid, model) {
  try {
    const res = await axios.put(`/api/public/v1/job-alerts/${uuid}`, model)
    return res.data.data || {}
  } catch (error) {
    console.warn(error);
    throw error;
  }
}

export async function deleteAlert(uuid) {
  try {
    const res = await axios.delete(`/api/public/v1/job-alerts/${uuid}`)
    return res.data.data || {}
  } catch (error) {
    console.warn(error);
    throw error;
  }
}
